import React from "react";
import { Loader2, Eraser } from "lucide-react";

const ORDER = ["pending", "ready", "rewriting", "rejected", "archived"];

function Breakdown({ by }) {
  const parts = ORDER.filter((s) => by?.[s]).map((s) => `${s} ${by[s]}`);
  return parts.length ? <span className="text-zinc-500"> · {parts.join(" · ")}</span> : null;
}

/** One click: delete never-published articles older than the stale-draft window. */
export function StaleDraftsBlock({ s }) {
  const { data, busy, draftsResult } = s;
  const plan = data.stale_drafts || {};
  const n = plan.deleted || 0;
  return (
    <div data-testid="storage-drafts" className="space-y-2 pt-3 border-t border-zinc-900">
      <div className="label-tiny">Never-published drafts</div>
      <div data-testid="storage-drafts-plan" className={`text-xs mono ${n ? "text-amber-300" : "text-zinc-600"}`}>
        <span className="inline-block w-14 text-right mr-2 tabular-nums">{n}</span>older than {plan.cutoff_days ?? 14}d<Breakdown by={plan.by_status} />
      </div>
      <button
        type="button" data-testid="storage-purge-drafts-btn" disabled={busy || !n} onClick={s.purgeDrafts}
        className="px-3 py-1.5 text-xs font-semibold border border-rose-700 text-rose-300 hover:border-rose-400 disabled:opacity-40 rounded-sm flex items-center gap-1.5"
      >{busy ? <Loader2 size={12} className="animate-spin" /> : <Eraser size={12} />} {n ? `Purge stale drafts (${n.toLocaleString()})` : "No stale drafts"}</button>
      {draftsResult && (
        <div data-testid="storage-purge-drafts-result" className="text-[11px] text-emerald-300 mono border border-emerald-900/60 bg-emerald-950/30 rounded-sm px-3 py-2">
          Deleted {draftsResult.deleted} draft(s) · {new Date(draftsResult.ran_at).toLocaleTimeString()}<Breakdown by={draftsResult.by_status} />
        </div>
      )}
      <div className="text-[11px] text-zinc-600 leading-relaxed">Pending, ready, rejected and archived-from-ready rows that never went live. No public URL existed, so nothing needs a 410. The daily sweep does this automatically too.</div>
    </div>
  );
}
